import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { use } from 'react';

import { SymbolContext, SymbolScope } from '@flipster/features/src/shared/symbol/bunja';
import { tradingSessionBunja, tradingSessionCheckBunja } from '@flipster/features/src/shared/trading-suspension/state';
import { T } from '@flipster/i18n';
import ClockCautionColorIcon from '@flipster/react/icon/generated/ClockCautionColorIcon';
import { css } from '@flipster/styled-system/css';

import { Ddd } from './ddd';

const MarketStatus = () => {
  const symbol = use(SymbolContext);
  const { isTradableAtom, currentMarketStatusAtom } = useBunja(tradingSessionBunja);
  const isTradable = useAtomValue(isTradableAtom);
  const currentMarketStatus = useAtomValue(currentMarketStatusAtom);
  const { openTradingHoursNoticeModal: handleOpenTradingHours } = useBunja(tradingSessionCheckBunja, [
    SymbolScope.bind(symbol),
  ]);

  if (!currentMarketStatus || currentMarketStatus === null) return null;

  return (
    <Ddd
      dt={<T id='Trade.r260305.Market_status' />}
      dd={
        <button type='button' onClick={() => handleOpenTradingHours()} className={css({ gap: 4 })}>
          {!isTradable && <ClockCautionColorIcon size={16} className={css({ verticalAlign: 'text-bottom', mr: 4 })} />}
          <span className={css({ textStyle: 'Text/M/Monospace/Underline', color: 'content.default.level-5' })}>
            <T id={marketStatusMessageId[currentMarketStatus]} />
          </span>
        </button>
      }
    />
  );
};

export default MarketStatus;

const marketStatusMessageId = {
  REGULAR: 'Trade.r260305.Market_status_regular',
  PRE_MARKET: 'Trade.r260305.Market_status_premarket',
  AFTER_MARKET: 'Trade.r260305.Market_status_aftermarket',
  OVER_NIGHT: 'Trade.r260305.Market_status_overnight',
  WEEKEND: 'Trade.r260305.Market_status_weekend',
  HOLIDAY: 'Trade.r260305.Market_status_holiday',
  MAINTENANCE: 'Trade.r260305.Market_status_maintenance',
} as const;
